export default __webpack_public_path__ + "static/media/Bib'sans-Bold.eca35464.otf";